module.exports = __webpack_public_path__ + "media/next_number_out_1.be278cdd.mp3";